import FnbPOS from "./FnbPOS";
export default function FnbPOSPage() {
  return <FnbPOS serviceKind="restaurant" showTables filterAlcoholic={null} testidPrefix="pos"/>;
}
